<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 营养门诊-健康行为记录
-->

<template>
  <div class="bodyinfo-page">
    <div class="title">健康行为记录</div>
    <div class="form-wrapper">
      <van-form @submit="onSubmit" :scroll-to-error="true">
        <div class="form-item" v-for="item in qsList" :key="item.name">
          <div class="form-item-label">{{ item.label }}</div>
          <div class="form-item-input">
            <van-field :name="item.name" :rules="[{ required: true, message: '请选择' }]">
              <template #input>
                <van-radio-group v-model="formData[item.name]" direction="vertical" icon-size="1.33rem">
                  <van-radio class="van-radio__label" v-for="opt in item.options" :key="opt.key" :name="opt.key"
                    checked-color="#FBB13D">{{ opt.label }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
        </div>


        <div class="next-btn-wrapper">
          <van-button round block color="#FBB13D" native-type="button" plain @click="onClickPrev">上一页</van-button>
          <van-button round block color="#FBB13D" type="info" native-type="submit">下一页</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HealthBehavior',
  props: {
    initData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      qsList: [{
        label: '1.中等强度运动（如快走、骑车）？',
        name: 'healthXwZdqdyd',
        options: [{
          label: "无",
          key: '0'
        },{
          label: "每周≥150分钟",
          key: '1'
        }, {
          label: "75-150分钟",
          key: '2'
        }, {
          label: "≤75分钟",
          key: '3'
        }]
      }, {
        label: '2.抗阻训练（如哑铃、俯卧撑）？',
        name: 'healthXwKzxl',
        options: [{
          label: "每周≥2次",
          key: '1'
        }, {
          label: "每周1次",
          key: '2'
        }, {
          label: "无",
          key: '3'
        }]
      }, {
        label: '3.平均每日睡眠时长？',
        name: 'healthXwPjmrsmsc',
        options: [{
          label: "≥7小时",
          key: '1'
        }, {
          label: "6-7小时",
          key: '2'
        }, {
          label: "≤6小时",
          key: '3'
        }]
      }, {
        label: '4.压力应对方式？',
        name: 'healthXwYlydfs',
        options: [{
          label: "运动调节",
          key: '1'
        }, {
          label: "倾诉沟通",
          key: '2'
        }, {
          label: "暴饮暴食",
          key: '3'
        }]
      }],
      formData: {
      }
    }
  },
  created() {

  },
  mounted() {

    this.formData = {...this.initData}
  },
  methods: {
    onSubmit(values) {
      let query = { ...values }
      console.log('onSubmit', values, query);
      this.$emit('next-step',{type:'healthBehavior',data:query})
    },
    onClickPrev() {
      this.$emit('prev-step')
    }
  }
};
</script>

<style scoped>
div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.bodyinfo-page {
  width: 100%;
  height: 100vh;
  padding: 2rem;
  background-color: #fff;
}

.bodyinfo-page .title {
  height: 2.33rem;
  font-weight: 500;
  font-size: 1.67rem;
  color: #333333;
  line-height: 2.33rem;
  margin-bottom: 2rem;
}

.form-wrapper {
  padding-bottom: 5rem;
}

.form-wrapper .form-item {
  margin-bottom: 2rem;
}

.form-wrapper .form-item .form-item-label {
  font-weight: 500;
  font-size: 1.33rem;
  color: #333333;
  line-height: 1.83rem;
  text-align: left;
  margin-bottom: 1rem;
}

.form-wrapper .form-item .form-item-input {
  /* width: 100%;
  height: 3.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  background: #F8F9FA; */
}

.icon-mark {
  width: 100px;
  font-size: 1.17rem;
}

.form-wrapper .form-item .form-item-input .van-cell {
  /* background: #F8F9FA; */
  padding-left: 0;
  border-bottom: 1px solid #e8e9ec;
}

.next-btn-wrapper {
  width: 100%;
  height: 6.9rem;
  display: flex;
  gap: 1.42rem;
  background-color: #fff;
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  padding: 0.33rem 2rem;
  box-shadow: inset 0rem 0.04rem 0rem 0rem rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
}

.form-wrapper .form-item .van-radio__label,
.bodyinfo-page .van-radio__label {
  font-size: 1.33rem;
  margin-bottom: 1rem;
}
</style>
